/* LUXONAS — live Timesact allocation on collection cards. */
(function () {
  'use strict';

  var STYLE_ID = 'lux-timesact-collection-allocation-style';

  function addStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = '.lux-product-card__allocation{margin:-4px 0 10px;font-size:12px;line-height:1.4;font-weight:600;letter-spacing:.04em;color:#8e7158}.lux-product-card__allocation[hidden]{display:none}';
    document.head.appendChild(style);
  }

  function timesactScriptText() {
    var scripts = document.scripts;
    for (var i = 0; i < scripts.length; i += 1) {
      var text = scripts[i].textContent || '';
      if (text.indexOf('window.TimesactData') !== -1 && text.indexOf('preOrderQuantitySold') !== -1) return text;
    }
    return '';
  }

  function productBlock(source, handle) {
    var marker = 'handle: "' + handle + '"';
    var start = source.indexOf(marker);
    if (start === -1) return '';
    var next = source.indexOf('handle: "', start + marker.length);
    return source.slice(start, next === -1 ? source.length : next);
  }

  function remainingAllocation(block) {
    var match = block.match(/"preOrderStatus":"ACTIVE"[\s\S]{0,260}?"preOrderQuantity":(\d+),"preOrderQuantitySold":(\d+)/);
    if (!match) return null;
    return Math.max(0, Number(match[1]) - Number(match[2]));
  }

  function cardHandle(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';
    var match = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  }

  function syncCollectionAllocations() {
    var cards = document.querySelectorAll('.lux-product-card');
    if (!cards.length) return;
    var source = timesactScriptText();
    if (!source) return;

    addStyle();

    Array.prototype.forEach.call(cards, function (card) {
      var handle = cardHandle(card);
      var remaining = handle ? remainingAllocation(productBlock(source, handle)) : null;
      var line = card.querySelector('.lux-product-card__allocation');

      if (remaining === null || remaining < 1) {
        if (line) line.remove();
        return;
      }

      if (!line) {
        var availability = card.querySelector('.lux-product-card__availability');
        if (!availability) return;
        line = document.createElement('div');
        line.className = 'lux-product-card__allocation';
        availability.insertAdjacentElement('afterend', line);
      }

      var label = remaining + ' available to reserve';
      if (line.textContent !== label) line.textContent = label;
    });
  }

  var timer;
  function scheduleSync() {
    window.clearTimeout(timer);
    timer = window.setTimeout(syncCollectionAllocations, 80);
  }

  [0, 250, 750, 1500, 3000].forEach(function (delay) {
    window.setTimeout(syncCollectionAllocations, delay);
  });

  if (document.body) {
    new MutationObserver(scheduleSync).observe(document.body, { childList: true, subtree: true });
  }
})();


/* LUXONAS — saved items, recently viewed and rail actions.
   No dependencies. The saved list itself stays on the visitor's own device and
   is never shared between customers. Saving additionally sends one anonymous
   analytics event naming the product only — no customer, no email, no id — so
   the shop can see which pieces people are keeping for later. */
(function () {
  'use strict';

  var SAVED_KEY = 'luxonas:saved';
  var VIEWED_KEY = 'luxonas:viewed';
  var VIEWED_MAX = 12;

  /* ---------------------------------------------------------------- store */

  function read(key) {
    try {
      var raw = window.localStorage.getItem(key);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function write(key, value) {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (e) {
      // Private browsing or a full quota: the page still works, it just forgets.
      return false;
    }
  }

  /* ------------------------------------------------------------- wishlist */

  var Saved = {
    all: function () {
      return read(SAVED_KEY).filter(function (entry) {
        return entry && typeof entry.handle === 'string' && entry.handle.length > 0;
      });
    },

    handles: function () {
      return Saved.all().map(function (entry) {
        return entry.handle;
      });
    },

    has: function (handle) {
      return Saved.handles().indexOf(handle) !== -1;
    },

    add: function (handle, productId) {
      var list = Saved.all().filter(function (entry) {
        return entry.handle !== handle;
      });
      list.unshift({ handle: handle, id: productId || null, savedAt: Date.now() });
      write(SAVED_KEY, list);
      announce();
    },

    remove: function (handle) {
      write(
        SAVED_KEY,
        Saved.all().filter(function (entry) {
          return entry.handle !== handle;
        })
      );
      announce();
    },

    toggle: function (handle, productId) {
      var saved = Saved.has(handle);
      if (saved) {
        Saved.remove(handle);
      } else {
        Saved.add(handle, productId);
      }
      return !saved;
    },

    /* Anything already stored on the customer's account is merged in once, so
       a list curated in Shopify admin (or written later by an app proxy)
       shows up alongside what this browser remembers. */
    mergeAccountList: function (handles) {
      if (!handles || !handles.length) return;
      var known = Saved.handles();
      var additions = handles.filter(function (handle) {
        return handle && known.indexOf(handle) === -1;
      });
      if (!additions.length) return;
      var list = Saved.all();
      additions.forEach(function (handle) {
        list.push({ handle: handle, id: null, savedAt: 0 });
      });
      write(SAVED_KEY, list);
    },
  };

  function announce() {
    var count = Saved.all().length;
    document.querySelectorAll('[data-lux-saved-count]').forEach(function (el) {
      el.textContent = count > 0 ? String(count) : '';
      el.classList.toggle('has-items', count > 0);
    });
    document.dispatchEvent(new CustomEvent('lux:saved:changed', { detail: { count: count } }));
  }

  function paintButton(button) {
    var saved = Saved.has(button.dataset.handle);
    button.setAttribute('aria-pressed', String(saved));
    button.classList.toggle('is-saved', saved);
    var text = button.querySelector('[data-lux-wish-text]');
    if (text) text.textContent = saved ? 'Saved' : 'Save';
  }

  function paintAllButtons() {
    document.querySelectorAll('[data-lux-wish]').forEach(paintButton);
  }

  function onWishClick(event) {
    var button = event.target.closest('[data-lux-wish]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();

    var nowSaved = Saved.toggle(button.dataset.handle, button.dataset.productId);
    paintAllButtons();

    if (nowSaved) {
      trackSave(button);
      var url = (window.LUXONAS_SAVED_URL || '').trim();
      toast(
        'Saved to your list',
        url ? { label: 'View saved items', href: url } : null
      );
    }
  }

  /* ---------------------------------------------------------- analytics */

  /* Aggregate only. We report WHICH piece was saved and nothing about who saved
     it — no customer id, no email, no list contents. GA4 is already loaded on
     the storefront and applies the visitor's existing consent choice, so this
     event is gated exactly like every other Google event on the site.

     `add_to_wishlist` is a standard GA4 recommended event, so the product name,
     category and vendor land in the normal Item name / Item category / Item
     brand dimensions with no custom setup. Category comes from the Shopify
     taxonomy category, since this catalogue does not use product_type.

     The Shopify custom event is published alongside it so a custom pixel can
     route the same signal elsewhere later (Meta, Klaviyo) without another
     theme change. Nothing subscribes to it today, which is harmless. */
  function trackSave(button) {
    var data = button.dataset || {};
    var price = parseFloat(data.productPrice);
    if (isNaN(price)) price = 0;

    var item = {
      item_id: data.productId || data.handle || '',
      item_name: data.productTitle || data.handle || '',
      price: price,
    };
    if (data.productCategory) item.item_category = data.productCategory;
    if (data.productVendor) item.item_brand = data.productVendor;

    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'add_to_wishlist', {
          currency: data.currency || 'EUR',
          value: price,
          items: [item],
        });
      }
    } catch (e) {
      /* Reporting must never stop a visitor saving something. */
    }

    try {
      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        window.Shopify.analytics.publish('luxonas_save_product', {
          handle: data.handle || '',
          productId: data.productId || '',
          title: data.productTitle || '',
          price: price,
          currency: data.currency || 'EUR',
        });
      }
    } catch (e) {
      /* Ditto. */
    }
  }

  /* -------------------------------------------------------- recently seen */

  var Viewed = {
    all: function () {
      return read(VIEWED_KEY).filter(function (handle) {
        return typeof handle === 'string' && handle.length > 0;
      });
    },

    record: function (handle) {
      if (!handle) return;
      var list = Viewed.all().filter(function (existing) {
        return existing !== handle;
      });
      list.unshift(handle);
      write(VIEWED_KEY, list.slice(0, VIEWED_MAX));
    },

    /* Everything seen apart from the page being looked at right now. */
    others: function (currentHandle, limit) {
      return Viewed.all()
        .filter(function (handle) {
          return handle !== currentHandle;
        })
        .slice(0, limit || 6);
    },
  };

  /* --------------------------------------------------------- card fetching */

  /* Cards are rendered by the theme through the Section Rendering API rather
     than rebuilt in JavaScript, so availability and dimensions stay governed
     by the same Liquid snippets as every other card on the site. */
  function fetchCard(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '?section_id=luxonas-card-render', {
      credentials: 'same-origin',
    })
      .then(function (response) {
        if (!response.ok) throw new Error('card unavailable');
        return response.text();
      })
      .then(function (html) {
        var holder = document.createElement('div');
        holder.innerHTML = html.trim();
        return holder.querySelector('[data-lux-rail-card]');
      })
      .catch(function () {
        return null;
      });
  }

  function renderRail(root) {
    var track = root.querySelector('[data-lux-rail-track]');
    if (!track) return Promise.resolve(0);

    var handles = (root.dataset.handles || '')
      .split(',')
      .map(function (handle) {
        return handle.trim();
      })
      .filter(Boolean);

    if (!handles.length) {
      root.hidden = true;
      return Promise.resolve(0);
    }

    return Promise.all(handles.map(fetchCard)).then(function (cards) {
      var rendered = 0;
      cards.forEach(function (card) {
        if (!card) return;
        var item = document.createElement('div');
        item.className = 'lux-rail__item';
        item.appendChild(card);
        track.appendChild(item);
        rendered += 1;
      });

      root.hidden = rendered === 0;
      root.classList.toggle('is-ready', rendered > 0);
      paintAllButtons();
      return rendered;
    });
  }

  /* -------------------------------------------------------------- add to cart */

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] }),
    }).then(function (response) {
      if (!response.ok) throw new Error('add failed');
      return response.json();
    });
  }

  function onRailAdd(event) {
    var button = event.target.closest('[data-lux-rail-add]');
    if (!button || button.disabled) return;
    event.preventDefault();

    var original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';

    addToCart(button.dataset.variantId, 1)
      .then(function () {
        button.textContent = 'Added';
        document.dispatchEvent(new CustomEvent('lux:cart:updated'));
        window.setTimeout(function () {
          button.disabled = false;
          button.textContent = original;
        }, 1800);
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = original;
        toast('Sorry, that could not be added. Please try the product page.');
      });
  }

  /* ------------------------------------------------------- add several at once */

  /* Only pieces without options are ever selectable — the markup simply does
     not render a checkbox for a product that needs a variant chosen — so this
     can never put the wrong variant in the cart. */
  function selectedIn(group) {
    return Array.prototype.slice
      .call(group.querySelectorAll('[data-lux-select]'))
      .filter(function (input) {
        return input.checked;
      });
  }

  function refreshSelectGroup(group) {
    var button = group.querySelector('[data-lux-add-selected]');
    if (!button) return;
    var count = selectedIn(group).length;
    button.disabled = count === 0;
    button.textContent = count > 0 ? 'Add selected (' + count + ')' : 'Add selected';
  }

  function onSelectChange(event) {
    var input = event.target.closest('[data-lux-select]');
    if (!input) return;
    var group = input.closest('[data-lux-select-group]');
    if (group) refreshSelectGroup(group);
  }

  function onAddSelected(event) {
    var button = event.target.closest('[data-lux-add-selected]');
    if (!button || button.disabled) return;
    event.preventDefault();

    var group = button.closest('[data-lux-select-group]');
    if (!group) return;

    var chosen = selectedIn(group);
    if (!chosen.length) return;

    var items = chosen.map(function (input) {
      return { id: Number(input.dataset.variantId), quantity: 1 };
    });

    var original = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return response.json();
      })
      .then(function () {
        chosen.forEach(function (input) {
          input.checked = false;
        });
        refreshSelectGroup(group);
        button.textContent = original;
        document.dispatchEvent(new CustomEvent('lux:cart:updated'));
        toast(
          items.length === 1 ? 'Added to your cart' : items.length + ' pieces added to your cart',
          { label: 'View cart', href: '/cart' }
        );
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = original;
        toast('Sorry, those could not be added. Please try the product pages.');
      });
  }

  /* ------------------------------------------------------------------ toast */

  var toastTimer = null;

  function toast(message, action) {
    var existing = document.querySelector('.lux-toast');
    if (existing) existing.remove();

    var el = document.createElement('div');
    el.className = 'lux-toast';
    el.setAttribute('role', 'status');

    var text = document.createElement('span');
    text.textContent = message;
    el.appendChild(text);

    if (action && action.href) {
      var link = document.createElement('a');
      link.href = action.href;
      link.textContent = action.label;
      el.appendChild(link);
    }

    document.body.appendChild(el);
    window.requestAnimationFrame(function () {
      el.classList.add('is-visible');
    });

    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      el.classList.remove('is-visible');
      window.setTimeout(function () {
        el.remove();
      }, 300);
    }, 4200);
  }

  /* ------------------------------------------------------------------- boot */

  function init() {
    Saved.mergeAccountList(window.LUXONAS_ACCOUNT_SAVED || []);

    if (window.LUXONAS_CURRENT_PRODUCT) {
      Viewed.record(window.LUXONAS_CURRENT_PRODUCT);
    }

    paintAllButtons();
    announce();

    document.addEventListener('click', onWishClick);
    document.addEventListener('click', onRailAdd);
    document.addEventListener('click', onAddSelected);
    document.addEventListener('change', onSelectChange);
    document.querySelectorAll('[data-lux-select-group]').forEach(refreshSelectGroup);

    // Recently viewed knows its handles only on the client.
    document.querySelectorAll('[data-lux-recently-viewed]').forEach(function (root) {
      var limit = parseInt(root.dataset.limit, 10) || 6;
      root.dataset.handles = Viewed.others(window.LUXONAS_CURRENT_PRODUCT, limit).join(',');
      renderRail(root);
    });

    document.querySelectorAll('[data-lux-saved-rail]').forEach(function (root) {
      var render = function () {
        var track = root.querySelector('[data-lux-rail-track]');
        if (track) track.innerHTML = '';
        root.dataset.handles = Saved.handles().join(',');
        var empty = document.querySelector('[data-lux-saved-empty]');
        renderRail(root).then(function (count) {
          root.hidden = count === 0;
          if (empty) empty.hidden = count > 0;
        });
      };
      render();
      document.addEventListener('lux:saved:changed', render);
    });
  }

  window.LuxonasSaved = Saved;
  window.LuxonasViewed = Viewed;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
